import 'whatwg-fetch';
require('es6-promise').polyfill();

import React from 'react/addons';
import Router from 'react-router';
import FluxComponent from 'flummox/component';
import Flux from './Flux';
import routes from './routes';

const flux = new Flux();
const deviceType = window.DEVICE_TYPE;

if (window.FLUX_DATA) {
  flux.deserialize(JSON.stringify(window.FLUX_DATA));
  delete window.FLUX_DATA;
}

if (deviceType !== 'desktop') {
  console.log('initTouch');
  React.initializeTouchEvents(true);
}

Router.run(routes, Router.HistoryLocation, Handler => {
  React.render(
    <FluxComponent flux={flux} connectToStores={['appState']}>
      <Handler deviceType={deviceType} />
    </FluxComponent>,
    document.getElementById('app')
  );
});

let serverSideStyle = document.getElementById('server-side-style');
if (serverSideStyle) {
  document.getElementsByTagName('head')[0].removeChild(serverSideStyle);
}



// WEBPACK FOOTER //
// ./src/client.js